import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";

class Options extends Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
  }

  static propTypes = {
    handleShowSaveContact: PropTypes.func.isRequired,
    handleCloseOptions: PropTypes.func.isRequired,
    isRename: PropTypes.bool,
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.menuRef.current && !this.menuRef.current.contains(event.target)) {
      this.props.handleCloseOptions();
    }
  };

  handleOpenSaveContact = () => {
    this.props.handleCloseOptions();
    this.props.handleShowSaveContact();
  };

  render() {
    const actionLabel = this.props.isRename ? "Rename Contact" : "Save Contact";
    return (
      <div
        ref={this.menuRef}
        className="absolute flex flex-col w-48 z-50 right-0 top-9 bg-white rounded-lg border border-gray-200 shadow-lg overflow-hidden"
      >
        <div
          onClick={this.handleOpenSaveContact}
          className="px-4 py-2.5 text-sm font-inter font-medium text-gray-800 hover:bg-gray-50 cursor-pointer transition-colors"
        >
          {actionLabel}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(withRouterHooks(Options));
